/* src/app/home/location-list/location/location.component.scss */
.location {
  width: 320px;
  position: relative;
  border: 1px solid #757575;
  margin-top: -1px;
  cursor: pointer;
}
.comments-indicator {
  height: 28px;
  width: 28px;
  background-color: #F88C00;
  border-radius: 50%;
  text-align: center;
  position: absolute;
  top: 2px;
  right: 1px;
  z-index: 99999999999;
}
.comments-indicator.icon::after {
  font-family: upsicons, fantasy !important;
  content: "\e62f" !important;
  color: #000000;
  font-size: 20px;
}
.ellipses-overflow {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.view-only,
.pending-removal {
  color: #6E6E6E;
  padding-left: 8px;
  font-weight: 400;
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
}
a {
  text-decoration: underline;
  color: #426DA9;
  font-size: 14px;
  line-height: 1.5;
}
.location-name {
  display: flex;
  align-items: flex-end;
}
.on-property {
  content: url(/assets/map.svg);
  height: 24px;
  width: 24px;
  display: flex;
}
.location-info {
  display: flex;
  flex-direction: column;
  padding-right: 16px;
  flex-grow: 1;
  min-width: 50%;
  max-width: 70%;
}
.location-metrics {
  display: flex;
  min-width: fit-content;
  justify-content: flex-end;
}
.location-metrics .metrics-counts {
  display: flex;
  flex-direction: column;
  padding-right: 0.5rem;
}
.location-metrics .metrics-counts span {
  text-align: right;
}
.location-metrics .metrics-labels {
  display: flex;
  flex-direction: column;
  padding: 0;
}
@media (min-width: 1280px) {
  .location {
    width: 346px;
  }
}
@media (min-width: 1880px) {
  .location {
    width: 360px;
  }
}
/*# sourceMappingURL=location.component.css.map */
